<template>
  <div class="text-center">
    <v-dialog v-model="visible" max-width="420">
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ dialogTitle }}</span>
        </v-card-title>
        <v-card-text>
          <div class="text-h6 pa-6">{{ bodyText }}</div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="showNegativeAction" text @click="negativeAction">{{negativeActionText}}</v-btn>
          <v-btn text color="primary" @click="positiveAction">{{
            positiveActionText
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: "confirmationDialog",
  props: ["visible", "dialogTitle", "negativeActionText", "showNegativeAction","positiveActionText", "bodyText"],
  components: {},
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close", false);
        }
      },
    },
  },
  methods: {
    positiveAction() {
      this.$emit("close", true);
    },
    negativeAction() {
      this.$emit("close", false);
    }
  },
};
</script>